var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.tabs),function(tab){return (tab === _vm.activeTab)?_vm._t(tab):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }